import * as React from 'react';
import { Button } from 'antd';
import { TableOutlined } from '@ant-design/icons';
import MapIcon from '@src/icons/charts/map.svg';

export interface VisualSwitchProps {
  value: 'table' | 'map';
  onChange: (value: VisualSwitchProps['value']) => void;
}

const VisualSwitch = (props: VisualSwitchProps) => (
  <Button
    icon={props.value === 'table' ? <MapIcon style={{ fontSize: 16 }} /> : <TableOutlined />}
    style={{
      border: 'none',
      boxShadow: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    onClick={() => props.onChange(props.value === 'table' ? 'map' : 'table')}
  />
);

export default React.memo(VisualSwitch);
